var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_188",
    "data-name": "Groupe 188",
    transform: "translate(-51.412 -159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_16",
    "data-name": "Soustraction 16",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM7.719,12.3a.632.632,0,0,0-.467.2.639.639,0,0,0-.193.461.8.8,0,0,0,.308.6,3.585,3.585,0,0,0,.983.614,3.948,3.948,0,0,0,1.12.262v.637a.688.688,0,0,0,.194.5.643.643,0,0,0,.477.2.681.681,0,0,0,.695-.694v-.706a2.978,2.978,0,0,0,1.513-.807,2.042,2.042,0,0,0,.592-1.479,2.032,2.032,0,0,0-.5-1.485,3.313,3.313,0,0,0-1.6-.768v-2.1a2.927,2.927,0,0,1,.967.49.5.5,0,0,0,.308.1.616.616,0,0,0,.455-.2.643.643,0,0,0,.193-.46.76.76,0,0,0-.33-.6,3.282,3.282,0,0,0-1.592-.707v-.42a.681.681,0,0,0-.194-.495.632.632,0,0,0-.477-.2.683.683,0,0,0-.695.695v.375a2.874,2.874,0,0,0-1.649.745A2.061,2.061,0,0,0,7.184,8.6c0,1.239.769,2.008,2.287,2.287v2.22a2.236,2.236,0,0,1-.694-.222,4.11,4.11,0,0,1-.671-.449A.6.6,0,0,0,7.719,12.3Zm3.118.7h0V11.222a1.365,1.365,0,0,1,.557.393.87.87,0,0,1,.182.551.694.694,0,0,1-.2.484,1.493,1.493,0,0,1-.533.357ZM9.471,9.526h0a1.681,1.681,0,0,1-.7-.369.817.817,0,0,1-.239-.61.787.787,0,0,1,.239-.579,1.34,1.34,0,0,1,.705-.33V9.525Z",
    transform: "translate(51.412 159)",
    fill: "#45434d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.e598fc92.svg";
export { ForwardRef as ReactComponent };